import { Controller } from "stimulus"

// Rooster 1 (#1515): sporters kiezen bij een afspraak. De server levert een
// gewone meervoudige keuzelijst (werkt ook zonder JavaScript); deze controller
// verbergt die en toont de gekozen sporters als chips met een zoekveld
// erboven. De keuzelijst blijft de bron: zoeken en klikken zetten alleen
// option.selected, zodat het formulier precies hetzelfde verstuurt.
//
// #1745: een open lead uit Sales & Leads (option data-lead) krijgt het label
// Lead en staat alleen in de zoekresultaten als het gekozen afspraaktype leads
// toelaat (option data-leads in de keuzelijst met name typeValue, de
// proefsessie). Zonder typeValue (doorplannen) beslist de server al welke
// leads er in de lijst staan.
export default class extends Controller {
  static targets = ["lijst"]
  static values = { geen: String, verwijder: String, zoek: String, type: String, lead: String }

  connect() {
    this.lijstTarget.hidden = true

    this.chips = document.createElement("div")
    this.chips.className = "ro-chips"
    this.chips.dataset.gekozenSporters = ""

    this.zoeker = document.createElement("div")
    this.zoeker.className = "ro-zoeker"
    this.invoer = document.createElement("input")
    this.invoer.type = "search"
    this.invoer.autocomplete = "off"
    this.invoer.placeholder = this.zoekValue
    this.invoer.setAttribute("aria-label", this.invoer.placeholder)
    this.resultaten = document.createElement("ul")
    this.resultaten.className = "ro-resultaten"
    this.resultaten.hidden = true
    this.zoeker.append(this.invoer, this.resultaten)

    this.lijstTarget.after(this.chips, this.zoeker)

    this.invoer.addEventListener("input", () => this.zoek())
    this.invoer.addEventListener("focus", () => this.zoek())
    this.invoer.addEventListener("keydown", (event) => this.toets(event))
    this.sluiten = (event) => { if (!this.zoeker.contains(event.target)) this.resultaten.hidden = true }
    document.addEventListener("click", this.sluiten)

    this.tekenChips()
  }

  disconnect() {
    document.removeEventListener("click", this.sluiten)
    if (this.chips) this.chips.remove()
    if (this.zoeker) this.zoeker.remove()
    this.lijstTarget.hidden = false
  }

  opties() {
    return Array.from(this.lijstTarget.options)
  }

  leadsToegestaan() {
    if (!this.typeValue) return true
    const veld = this.element.closest("form")?.querySelector(`select[name="${this.typeValue}"]`)
    if (!veld) return true
    const gekozen = veld.options[veld.selectedIndex]
    return Boolean(gekozen && gekozen.dataset.leads)
  }

  // De naam, met het label Lead erachter als het een lead is
  vulNaam(element, optie) {
    element.append(document.createTextNode(optie.dataset.naam || optie.text))
    if (!optie.dataset.lead) return

    const label = document.createElement("span")
    label.className = "ro-lead-label"
    label.dataset.leadLabel = ""
    label.textContent = this.leadValue || "Lead"
    element.append(document.createTextNode(" "), label)
  }

  zoek() {
    const term = this.invoer.value.trim().toLowerCase()
    const leads = this.leadsToegestaan()
    const treffers = this.opties()
      .filter((optie) => !optie.selected && (leads || !optie.dataset.lead))
      .filter((optie) => term === "" || optie.text.toLowerCase().includes(term))
      .slice(0, 30)

    this.resultaten.innerHTML = ""
    if (treffers.length === 0) {
      const leeg = document.createElement("li")
      leeg.className = "ro-geen"
      leeg.textContent = this.geenValue
      this.resultaten.append(leeg)
    }
    treffers.forEach((optie, index) => {
      const regel = document.createElement("li")
      const knop = document.createElement("button")
      knop.type = "button"
      this.vulNaam(knop, optie)
      knop.dataset.waarde = optie.value
      if (index === 0) knop.classList.add("is-actief")
      knop.addEventListener("click", () => this.kies(optie))
      regel.append(knop)
      this.resultaten.append(regel)
    })
    this.resultaten.hidden = false
  }

  toets(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      const eerste = this.resultaten.querySelector("button.is-actief")
      if (eerste) eerste.click()
    } else if (event.key === "Escape") {
      this.resultaten.hidden = true
    }
  }

  kies(optie) {
    optie.selected = true
    this.invoer.value = ""
    this.resultaten.hidden = true
    this.tekenChips()
    this.lijstTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.invoer.focus()
  }

  verwijder(optie) {
    optie.selected = false
    this.tekenChips()
    this.lijstTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  tekenChips() {
    this.chips.innerHTML = ""
    this.opties().filter((optie) => optie.selected).forEach((optie) => {
      const chip = document.createElement("span")
      chip.className = "ro-chip"
      chip.dataset.sporterId = optie.value
      if (optie.dataset.lead) chip.classList.add("is-lead")
      this.vulNaam(chip, optie)
      const knop = document.createElement("button")
      knop.type = "button"
      knop.textContent = "×"
      knop.setAttribute("aria-label", this.verwijderValue.replace("%{naam}", optie.text))
      knop.addEventListener("click", () => this.verwijder(optie))
      chip.append(knop)
      this.chips.append(chip)
    })
  }
}
